/* PR collection page (2026-10-05): filter panel, sort select, photo dots, "ver más" loading and the header animation
   of sections/pr-collection, plus its campaign rows (videos, fading photos). Styles in assets/pr-collection.css.
   Filters work as on the reference (prada.com): no "apply" button — ticking an option reloads the products, the
   count and the panel in place (the section is fetched again with the new address), and the panel stays open. */
(() => {
  if (window.__prCollection) return;
  window.__prCollection = true;
  const root = document.documentElement;

  /* Second photos (2026-10-05, scroll fluency): they come without an address. One gets it when the pointer or a
     finger reaches its card, or when scrolling has been still for a moment with the card on screen. */
  const waiting = new Set(); // cards whose second photo has no address yet
  function loadSecond(card) {
    waiting.delete(card);
    const img = card.querySelector('img[data-pr-src]');
    if (!img) return;
    img.srcset = img.dataset.prSrcset || '';
    img.src = img.dataset.prSrc;
    img.removeAttribute('data-pr-src');
    img.removeAttribute('data-pr-srcset');
  }
  let stillTimer = 0;
  const whenStill = () => {
    clearTimeout(stillTimer);
    stillTimer = setTimeout(() => {
      const run = () => {
        const vh = window.innerHeight;
        [...waiting].forEach((card) => {
          const r = card.getBoundingClientRect();
          if (r.bottom > -200 && r.top < vh + 200) loadSecond(card);
        });
      };
      if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 1000 }); else run();
    }, 350);
  };
  window.addEventListener('scroll', whenStill, { passive: true });

  /* Photo dots (phones): the dot follows the photo in view */
  function initCards(scope) {
    (scope || document).querySelectorAll('[data-pr-card]:not([data-pr-ready])').forEach((card) => {
      card.dataset.prReady = '1';
      if (card.querySelector('img[data-pr-src]')) {
        const now = () => loadSecond(card);
        card.addEventListener('pointerenter', now, { once: true });
        card.addEventListener('touchstart', now, { once: true, passive: true });
        card.addEventListener('focusin', now, { once: true });
        waiting.add(card);
      }
      const track = card.querySelector('[data-pr-track]');
      const dots = card.querySelectorAll('.pr-pc__dots span');
      if (!track || dots.length < 2) return;
      track.addEventListener('scroll', () => {
        const i = track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
        dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
      }, { passive: true });
    });
  }

  /* Campaign rows (snippets/pr-collection-banner, 2026-10-05). Videos come without preload: the one for this screen
     size plays while its row is on screen and stops when it leaves (the other one is never downloaded). The photos
     of "foto con texto" fade into each other every 2s (0.6s fade), as on the reference. */
  const banVideos = new Set();
  const playVisible = () => {
    const vh = window.innerHeight;
    banVideos.forEach((v) => {
      if (!v.isConnected) { banVideos.delete(v); return; }
      const r = v.getBoundingClientRect();
      const on = r.width > 0 && r.bottom > 0 && r.top < vh; // width 0 = the video of the other screen size
      if (on && v.paused) { v.muted = true; const p = v.play(); if (p && p.catch) p.catch(() => {}); }
      else if (!on && !v.paused) v.pause();
    });
  };
  let banQueued = false;
  const banCheck = () => { if (banQueued) return; banQueued = true; requestAnimationFrame(() => { banQueued = false; playVisible(); }); };
  window.addEventListener('scroll', banCheck, { passive: true });
  window.addEventListener('resize', banCheck);
  function initBanners(scope) {
    (scope || document).querySelectorAll('[data-pr-banner]:not([data-pr-ready])').forEach((ban) => {
      ban.dataset.prReady = '1';
      ban.querySelectorAll('video').forEach((v) => {
        v.muted = true; v.loop = true; v.playsInline = true;
        v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
        banVideos.add(v);
      });
      const box = ban.querySelector('[data-pr-ban-fade]');
      const slides = box ? box.querySelectorAll('.pr-ban__slide') : [];
      if (slides.length > 1) {
        let i = 0;
        slides[0].classList.add('is-on');
        box.classList.add('is-ready');
        setInterval(() => {
          if (!box.isConnected || document.hidden) return;
          slides[i].classList.remove('is-on');
          i = (i + 1) % slides.length;
          slides[i].classList.add('is-on');
        }, 2600);
      }
    });
    playVisible();
  }

  function initCollection() {
    document.querySelectorAll('[data-pr-collection]:not([data-pr-ready])').forEach((col) => {
      col.dataset.prReady = '1';
      const sectionId = col.dataset.sectionId;
      const auto = col.dataset.prAuto === 'true';
      const sectionUrl = (href) => {
        const url = new URL(href, window.location.origin);
        url.searchParams.set('section_id', sectionId);
        return url.toString();
      };

      /* Height of the two rows, for anything that has to stop under them */
      const bars = col.querySelector('[data-pr-bars]');
      const host = col.closest('.shopify-section') || col;
      if (bars) {
        const measure = () => host.style.setProperty('--pr-bars-height', bars.offsetHeight + 'px');
        measure();
        if (window.ResizeObserver) new ResizeObserver(measure).observe(bars);
        else window.addEventListener('resize', measure);
      }

      /* Sort: keeps the filters in the URL, back to the first page */
      const sort = col.querySelector('[data-pr-sort]');
      if (sort) sort.addEventListener('change', () => {
        const url = new URL(window.__prShort ? window.__prShort.realHref() : window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });

      /* Current category in view in the scrolling row: the row only moves when it would be cut off. */
      const nav = col.querySelector('[data-pr-nav]');
      const active = nav && nav.querySelector('a.is-active');
      if (active && nav.scrollWidth > nav.clientWidth) {
        const end = active.getBoundingClientRect().right - nav.getBoundingClientRect().left;
        if (end > nav.clientWidth - 16) nav.scrollLeft = end - nav.clientWidth + 32;
      }

      /* More products: the "ver más" link (and on scroll with data-pr-auto="true") */
      let loading = false;
      let io = null;
      const observe = () => {
        if (io) io.disconnect();
        const more = col.querySelector('[data-pr-more]');
        if (!auto || !more || !('IntersectionObserver' in window)) return;
        io = new IntersectionObserver((entries) => { if (entries.some((en) => en.isIntersecting)) load(); }, { rootMargin: '800px 0px' });
        io.observe(more);
      };
      function load() {
        const grid = col.querySelector('[data-pr-grid]');
        const more = col.querySelector('[data-pr-more]');
        const link = more && more.querySelector('[data-pr-next-url]');
        if (loading || !grid || !link) return;
        loading = true;
        more.classList.add('is-loading');
        fetch(sectionUrl(link.href))
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            doc.querySelectorAll('[data-pr-grid] > *').forEach((c) => grid.appendChild(document.importNode(c, true)));
            initCards(grid);
            document.dispatchEvent(new CustomEvent('pd:refresh'));
            initBanners(grid);
            whenStill();
            const nextMore = doc.querySelector('[data-pr-more]');
            if (nextMore) more.replaceWith(document.importNode(nextMore, true));
            else more.remove();
            observe();
          })
          .catch(() => { window.location.href = link.href; })
          .finally(() => { loading = false; const m = col.querySelector('[data-pr-more]'); if (m) m.classList.remove('is-loading'); });
      }
      col.addEventListener('click', (e) => { if (e.target.closest('[data-pr-next-url]')) { e.preventDefault(); load(); } });
      observe();

      /* Filter panel */
      const panel = col.querySelector('[data-pr-filter]');
      const openBtn = col.querySelector('[data-pr-filter-open]');
      if (!panel || !openBtn) return;
      // Out of the section so no transformed ancestor can clip the fixed panel.
      const old = document.getElementById(panel.id);
      if (old && old !== panel && !col.contains(old)) old.remove();
      document.body.appendChild(panel);
      const open = () => { panel.classList.add('is-open'); panel.setAttribute('aria-hidden', 'false'); openBtn.setAttribute('aria-expanded', 'true'); root.classList.add('pr-lock'); };
      const close = () => { panel.classList.remove('is-open'); panel.setAttribute('aria-hidden', 'true'); openBtn.setAttribute('aria-expanded', 'false'); root.classList.remove('pr-lock'); openBtn.focus({ preventScroll: true }); };
      openBtn.addEventListener('click', open);
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && panel.classList.contains('is-open')) close(); });

      const form = panel.querySelector('[data-pr-filter-form]');
      const body = panel.querySelector('[data-pr-filter-body]');
      const clear = panel.querySelector('[data-pr-filter-clear]');
      const expanded = new Set(); // groups opened with "mostrar más" stay open when the panel is redrawn
      let request = 0;

      // The products, the count and the panel for the options ticked now
      function apply() {
        if (!form) return;
        const params = new URLSearchParams(new FormData(form));
        [...params.keys()].forEach((k) => { if (params.getAll(k).every((v) => v === '')) params.delete(k); });
        const qs = params.toString();
        const href = form.getAttribute('action') + (qs ? `?${qs}` : '');
        const mine = ++request;
        const results = col.querySelector('[data-pr-results]');
        if (results) results.classList.add('is-loading');
        fetch(sectionUrl(href))
          .then((r) => r.text())
          .then((html) => {
            if (mine !== request) return; // a newer choice is on its way
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const swap = (sel, into) => {
              const fresh = doc.querySelector(sel);
              const cur = (into || col).querySelector(sel);
              if (fresh && cur) cur.innerHTML = fresh.innerHTML;
            };
            swap('[data-pr-results]');
            swap('[data-pr-count]');
            swap('[data-pr-filter-open]');
            if (body) {
              const focused = document.activeElement && body.contains(document.activeElement) ? document.activeElement.id : '';
              swap('[data-pr-filter-body]', panel);
              body.querySelectorAll('[data-pr-filter-group]').forEach((g) => { if (expanded.has(g.dataset.prFilterGroup)) setExpanded(g, true); });
              if (focused) { const el = document.getElementById(focused); if (el) el.focus({ preventScroll: true }); }
            }
            const freshClear = doc.querySelector('[data-pr-filter-clear]');
            if (clear && freshClear) clear.className = freshClear.className;
            window.history.replaceState(window.history.state, '', href);
            if (window.__prShort) window.__prShort.apply();
            initCards(col);
            document.dispatchEvent(new CustomEvent('pd:refresh'));
            initBanners(col);
            whenStill();
            observe();
          })
          .catch(() => { window.location.href = href; })
          .finally(() => { if (mine === request && results) results.classList.remove('is-loading'); });
      }

      function setExpanded(group, on) {
        group.classList.toggle('is-expanded', on);
        const btn = group.querySelector('[data-pr-filter-more]');
        if (btn) { btn.setAttribute('aria-expanded', on ? 'true' : 'false'); btn.textContent = on ? btn.dataset.less : btn.dataset.more; }
      }

      if (form) {
        form.addEventListener('change', apply);
        form.addEventListener('submit', (e) => { e.preventDefault(); apply(); });
      }
      panel.addEventListener('click', (e) => {
        if (e.target.closest('[data-pr-filter-close]')) { close(); return; }
        const more = e.target.closest('[data-pr-filter-more]');
        if (more) {
          const group = more.closest('[data-pr-filter-group]');
          const on = !group.classList.contains('is-expanded');
          setExpanded(group, on);
          if (on) expanded.add(group.dataset.prFilterGroup); else expanded.delete(group.dataset.prFilterGroup);
          return;
        }
        if (e.target.closest('[data-pr-filter-clear]')) {
          e.preventDefault();
          if (!form) return;
          form.querySelectorAll('input[type="checkbox"]').forEach((i) => { i.checked = false; });
          form.querySelectorAll('input[type="number"]').forEach((i) => { i.value = ''; });
          apply();
        }
      });
    });
  }

  /* Header and rows tied to the scroll (2026-10-05, user: "al bajar tapa los productos, deberían de ir de la mano").
     Before, the header slid away / came back whole, on its own 0.3s animation, as soon as the page turned: going up a
     few pixels brought down 72px of header over products that were in view. Now the header and the two rows move
     exactly as much as the page does, like one more piece of it: n pixels down take them n pixels up (until the
     header is out), n pixels up bring them n pixels back. On phones the rows go up 40px more, so the name of the
     group leaves too ("al hacer scroll down no mostrar título"). Written on the two elements, not on <html>. */
  function initHeader() {
    if (!document.querySelector('[data-pr-collection]') || root.classList.contains('pr-hdr')) return;
    const header = document.querySelector('.header__outer-wrapper');
    if (!header) return;
    root.classList.add('pr-hdr');
    const phone = window.matchMedia('(max-width: 767px)');
    let headerH = header.offsetHeight;
    let lastY = Math.max(0, window.scrollY);
    let shift = 0; // how far up the header and the rows are, in px
    let drawn = -1;
    let queued = false;
    // never away while a menu, the search or a panel is open
    const busy = () => root.classList.contains('pr-lock')
      || document.body.getAttribute('mobile-menu-open') === 'true'
      || document.body.getAttribute('quick-search-open') === 'true';
    const draw = (animate) => {
      const dpr = window.devicePixelRatio || 1;
      const px = Math.round(shift * dpr) / dpr;
      if (px === drawn) return;
      drawn = px;
      const move = animate ? 'transform .3s ease' : '';
      header.style.transition = move;
      header.style.transform = px ? `translate3d(0, ${-Math.min(px, headerH)}px, 0)` : '';
      document.querySelectorAll('[data-pr-bars]').forEach((bars) => {
        bars.style.transition = animate ? 'top .45s ease, transform .3s ease' : '';
        bars.style.transform = px ? `translate3d(0, ${-px}px, 0)` : '';
      });
    };
    const update = () => {
      queued = false;
      const y = Math.max(0, window.scrollY);
      const delta = y - lastY;
      lastY = y;
      if (busy()) { if (shift) { shift = 0; draw(true); } return; }
      const max = headerH + (phone.matches ? 40 : 0);
      // never further up than the page itself has gone: at the very top everything is in its place
      shift = Math.max(0, Math.min(shift + delta, max, y));
      draw(false);
    };
    const ask = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', ask, { passive: true });
    window.addEventListener('resize', () => { headerH = header.offsetHeight; ask(); });
    // a menu, the search or the filters opening brings the header back
    new MutationObserver(() => { if (shift && busy()) { shift = 0; draw(true); } })
      .observe(document.body, { attributes: true, attributeFilter: ['mobile-menu-open', 'quick-search-open'] });
    new MutationObserver(() => { if (shift && busy()) { shift = 0; draw(true); } })
      .observe(root, { attributes: true, attributeFilter: ['class'] });
  }

  const init = () => { initCards(); initBanners(); initCollection(); initHeader(); whenStill(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
